import { wrap as withStyle } from 'utils/styles'

export default withStyle((props) => {
  const {
    theme: {
      modalWizardPrimary,
      modalWizardBtnFontColor,
      modalWizardBtnBackground,
      modalWizardBtnBorder,
    },
  } = props

  return `
  && {
        .modal-wizard_step-description {
          display: flex;
          margin-top: 10px;
          justify-content: center;
        }

       .ant-btn-primary {
          background-color: ${modalWizardPrimary};
        }

       .ant-btn {
          color: ${modalWizardBtnFontColor};
          background-color: ${modalWizardBtnBackground};
          border-color: ${modalWizardBtnBorder};
        }

  }
  `
})
